import React, { useEffect, useState } from 'react';
import FeatherIcon from 'feather-icons-react';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { useExcryptedNavigation } from '../Filters/FilterConditions';
import { Button } from '../../../components/buttons/buttons';

const Popup = ({ confirmPopup, setConfirmPopup, linkUrl, page, CallBack }) => {
    const dispatch = useDispatch();
    const [navUrl, setNavUrl] = useState()
    async function Click() {
        setConfirmPopup(false)
        dispatch(setEditCall(false));
    }
    async function ClickOpen() {
        setConfirmPopup(false)
        dispatch(setEditCall(false));
        CallBack(navUrl?.navLink)
    }
    const handleClose = () => {
        setConfirmPopup(false)
    }
    const { ExcryptedNavigation } = useExcryptedNavigation();
    async function getOtherUrls() {
        const response = await ExcryptedNavigation("Return", linkUrl.Id, linkUrl.entity, null, null, null, null)
        if (response.status) {
            setNavUrl({ navLink: response.url, type: response.status })
        }
    }
    useEffect(() => {
        if (linkUrl) {
            if (linkUrl.type === "Normal") {
                setNavUrl({ navLink: linkUrl.url, type: true })
            } else {
                getOtherUrls()
            }
        }
    }, [linkUrl])
    return (
        <>
            <Modal
                title="Leave Page?"
                open={confirmPopup}
                onCancel={handleClose}
                maskClosable={false}
                footer={[
                    <div>
                        <Button htmlType="submit" size="small" className="gray-button" onClick={handleClose}>
                            <FeatherIcon icon="x" /> No
                        </Button>
                        {navUrl?.type ?
                            (page === "Shortcut" ?
                                <Button htmlType="submit" onClick={ClickOpen} className='button_colors' size="small">
                                    <FeatherIcon icon="check" /> Yes
                                </Button>
                                :
                                <NavLink to={navUrl?.navLink} style={{ margin: "0px 0px 0px 15px" }}>
                                    <Button htmlType="submit" onClick={Click} className='button_colors' size="small">
                                        <FeatherIcon icon="check" /> Yes
                                    </Button>
                                </NavLink>) : <></>}
                    </div >
                ]}
            >
                <div style={{ padding: "0px 20px" }} >
                    <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                        <p>Are you sure you want to leave this page? any unsaved changes will be lost</p>
                    </div>
                </div>
            </Modal >

        </>
    );
};

Popup.propTypes = {
    confirmPopup: PropTypes.bool.isRequired,
    setConfirmPopup: PropTypes.func.isRequired,
    CallBack: PropTypes.func.isRequired,
    linkUrl: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
};

export default Popup;